import React from "react";
import ECLBlock from "../ECLBlock";
import { translate } from "../../../utilities/Translate";
import "./Tabs.css";

export default function Tabs(props) {
   function changeActiveTab(index) {
      props.setFlatDoc({
         ...props.flatDoc,
         [props.flatKey]: {
            ...props.flatDoc[props.flatKey],
            react: {
               ...props.flatDoc[props.flatKey].react,
               activeTab: index,
            },
         },
      });
   }

   return (
      <>
         <div className="blockument-tab-container">
            {props.block.children.map((t, i) => {
               return (
                  <button
                     key={t}
                     onClick={(e) => {
                        e.preventDefault();
                        changeActiveTab(i);
                     }}
                     className={
                        i === props.block.react.activeTab
                           ? "tab-button-active"
                           : "tab-button"
                     }
                     title={props.flatDoc[t].data.name}
                  >
                     {translate(props.flatDoc[t].data.name)}
                  </button>
               );
            })}
         </div>
         {props.flatDoc[
            props.block.children[props.block.react.activeTab]
         ].children.map((c) => (
            <ECLBlock
               key={c}
               block={props.flatDoc[c]}
               project={props.project}
               flatDoc={props.flatDoc}
               setFlatDoc={props.setFlatDoc}
               flatKey={c}
               headlist={props.headlist}
               parentDoc={props.parentDoc}
               revisionCount={props.revisionCount}
               incrementRevision={props.incrementRevision}
               navigateTo={props.navigateTo}
               setNavigateTo={props.setNavigateTo}
            />
         ))}
      </>
   );
}
